<template>
  <div>
    <!-- 컨텐츠 -->
    <div class="content-wrap">
      <!-- 개인정보 수집 및 이용 동의 -->
      <div v-if="data.openPrivateTerms">
        <private-terms @toStep1="toStep1"> </private-terms>
      </div>
      <!-- //개인정보 수집 및 이용 동의 -->
      <!-- 신원인증 시작. step1 -->
      <div v-else class="step">
        <div class="top-wrap" flex fjb>
          <div class="step-title">
            {{ $t("Verification.step1.start") }}
          </div>
          <div class="step-number" flex>
            <div class="number active">1</div>
            <div class="number ml8">2</div>
            <div class="number ml8">3</div>
            <div class="number ml8">4</div>
          </div>
        </div>
        <div class="pt20">
          <!-- 내국인/외국인 확인 -->
          <div class="item">
            <div class="title mb8">
              {{ $t("Verification.step1.checkKorean.title") }}
            </div>
            <div class="button-wrap" flex>
              <button
                @click="clickKorean"
                class="default half"
                :class="{ selected: data.selectedKorean }"
              >
                {{ $t("Verification.step1.checkKorean.description[0]") }}
              </button>
              <button
                @click="clickForeigner"
                disabled
                class="default half ml12"
                :class="{ selected: data.selectedForeigner }"
              >
                {{ $t("Verification.step1.checkKorean.description[1]") }}
              </button>
            </div>
          </div>
          <!-- //내국인/외국인 확인 -->

          <!-- 국적 확인 -->
          <div class="item mt32">
            <div class="title mb8">
              {{ $t("Verification.step1.nationality.title") }}
            </div>
            <div class="el-input is-disabled top-content">
              <!-- 외국인 선택 시 -->
              <div v-if="data.selectedForeigner">
                <div
                  @click="openNationsModal"
                  class="button-wrap select-box foreigner"
                >
                  <div class="item">
                    <div class="detail dropdown fs12">
                      {{ data.nationality }}
                    </div>
                  </div>
                </div>
              </div>
              <!-- 내국인 선택 시 -->
              <div v-else>
                <el-input type="text" :value="data.nationality" disabled />
              </div>
            </div>
          </div>
          <!-- //국적 확인 -->

          <!-- 거주 / 비거주 여부 확인 -->
          <div class="item mt32">
            <div class="title mb8">
              {{ $t("Verification.step1.checkNationality.title") }}
            </div>
            <div class="button-wrap" flex>
              <button
                @click="clickLiveKorea"
                :disabled="!data.abled"
                class="default disabled half"
                :class="{ abled: data.abled, selected: data.domesticYn == 'Y' }"
              >
                {{ $t("Verification.step1.checkNationality.description[0]") }}
              </button>
              <!-- 비거주 버튼 활성화 되면 살릴 코드
               :disabled="!data.abled || data.selectedForeigner" 
               -->
              <button
                @click="clickLiveOter"
                disabled
                class="default disabled half ml12"
                :class="{ abled: data.abled, selected: data.liveInAnothers }"
              >
                {{ $t("Verification.step1.checkNationality.description[1]") }}
              </button>
            </div>
          </div>
          <!-- //거주 / 비거주 여부 확인 -->

          <!-- 개인정보 수집 및 이용에 대한 동의 -->
          <div class="item mt45">
            <div class="title">
              {{ $t("Verification.step1.privacy") }}
              <span class="keycolor">{{
                $t("Verification.common.required")
              }}</span>
              <div class="button-wrap mt18" flex fjb>
                <el-checkbox
                  :label="$t('Verification.step1.privacyAgree')"
                  v-model="data.agreeChecked"
                  class="agree-checked"
                ></el-checkbox>
                <div class="detail-noti">
                  <a
                    v-if="data.selectedForeigner"
                    :href="zendeskUrl['en']['identificationForeign']"
                    style="margin: 0 0 0 0; padding: 0 0 0 0"
                    target="_blank"
                  >
                    {{ $t("Verification.step1.learnMore") }}
                  </a>
                  <a
                    v-else
                    :href="zendeskUrl['ko']['identification']"
                    style="margin: 0 0 0 0; padding: 0 0 0 0"
                    target="_blank"
                  >
                    {{ $t("Verification.step1.learnMore") }}
                  </a>
                </div>
              </div>
            </div>
          </div>
          <!-- //개인정보 수집 및 이용에 대한 동의 -->

          <!-- 고유식별정보 수집 및 이용에 대한 동의 -->
          <div class="item mt45">
            <div class="title">
              {{ $t("Verification.step1.unique") }}
              <span class="keycolor">{{
                $t("Verification.common.required")
              }}</span>
              <div class="button-wrap mt18" flex fjb>
                <el-checkbox
                  :label="$t('Verification.step1.privacyAgree')"
                  v-model="data.unique"
                  class="agree-checked"
                ></el-checkbox>
                <div class="detail-noti">
                  <a
                    v-if="data.selectedForeigner"
                    :href="zendeskUrl['en']['uniqueIdentifyForeign']"
                    style="margin: 0 0 0 0; padding: 0 0 0 0"
                    target="_blank"
                  >
                    {{ $t("Verification.step1.learnMore") }}
                  </a>
                  <a
                    v-else
                    :href="zendeskUrl['ko']['uniqueIdentifyKorea']"
                    style="margin: 0 0 0 0; padding: 0 0 0 0"
                    target="_blank"
                  >
                    {{ $t("Verification.step1.learnMore") }}
                  </a>
                </div>
              </div>
            </div>
          </div>
          <!-- //고유식별정보 수집 및 이용에 대한 동의 -->

          <!-- 기타 고지사항 -->
          <div class="item mt45">
            <div class="title">
              <!-- {{ "기타 고지사항" }} -->
              <div class="button-wrap mt18" flex fjb>
                <div>{{ "기타 고지사항" }}</div>
                <div class="detail-noti">
                  <a
                    v-if="data.selectedForeigner"
                    :href="zendeskUrl['en']['authNotification']"
                    style="margin: 0 0 0 0; padding: 0 0 0 0"
                    target="_blank"
                  >
                    {{ $t("Verification.step1.learnMore") }}
                  </a>
                  <a
                    v-else
                    :href="zendeskUrl['ko']['authNotification']"
                    style="margin: 0 0 0 0; padding: 0 0 0 0"
                    target="_blank"
                  >
                    {{ $t("Verification.step1.learnMore") }}
                  </a>
                </div>
              </div>
            </div>
          </div>
          <!-- // 기타 고지사항 -->

          <!-- 다음 버튼 -->
          <button
            @click="toStep2"
            :disabled="
              this.data.nationality == '국적을 선택해 주세요.' ||
              (this.data.domesticYn == 'Y' || this.data.liveInAnothers) ==
                false ||
              this.data.agreeChecked == false ||
              this.data.unique == false
            "
            class="next-button mt30"
          >
            {{ $t("Verification.common.next") }}
          </button>
          <!-- //다음 버튼 -->
        </div>
      </div>
      <!-- //신원인증 시작. step1 -->
    </div>
    <!-- //컨텐츠 -->

    <!-- 외국인 국가 선택 팝업 -->
    <el-dialog
      :visible.sync="data.nationsModal"
      :title="$t('Verification.step1.selectYourNationality')"
      :close-on-click-modal="false"
      class="authID-modal"
    >
      <el-radio-group v-model="data.nationality" @change="changeNationseModal">
        <ul class="dropdown-list">
          <li
            v-for="(item, index) in data.nationItems"
            :key="index"
            class="pl12"
          >
            <el-radio :label="item.cntName + '/' + item.cntNameKo"></el-radio>
          </li>
        </ul>
      </el-radio-group>
    </el-dialog>
    <!-- // 외국인 국가 선택 팝업 -->

    <!-- 내국인<->외국인 교차 인증 불가 팝업 -->
    <vs-popup
      title="내국인 / 외국인 교차 인증 불가"
      :button-close-hidden="true"
      :active.sync="doNotChangeModal"
      class="medium-popup"
    >
      <div class="text-wrap">
        <div class="text-detail">
          <div class="text-box mt0">
            <p class="title ta-c">
              {{ "회원님, 국적을 변경하셨나요?" }}
            </p>
            <div class="contents gray-box">
              <div class="list ta-c">
                내국인 → 외국인 또는<br />외국인 → 내국인으로<br /><br />국적이
                변경되신 경우<br />고객센터 문의를<br />부탁드립니다.
              </div>
            </div>
          </div>
        </div>
      </div>
      <div class="button-wrap">
        <button @click="clickOkButton">{{ $t("confirm.ok") }}</button>
      </div>
    </vs-popup>
    <!-- //내국인<->외국인 교차 인증 불가 팝업 -->
  </div>
</template>
<script>
import privateTerms from "./privateTerms.vue";
import CookieControl from "@/common/CookieControl";
import Api from "@/common/Api";
import { mapState } from "vuex";

export default {
  components: {
    privateTerms,
  },
  created() {
    window.scrollTo(0, 0);
  },
  props: {
    data: {
      private: Boolean, // 개인정보 수집 및 이용 동의
      nationality: String, // 국적 확인
      colorChange: Boolean, //폰트 컬러 #333으로 변경
      selectedKorean: Boolean, // 내국인 선택
      selectedForeigner: Boolean, // 외국인 선택
      abled: Boolean, //disabled 아닌 상태
      domesticYn: String, //국내 거주
      liveInAnothers: Boolean, //국내 비거주
      agreeChecked: Boolean, //개인정보 수집 이용 동의 체크박스
      unique: Boolean, //고유식별정보 수집 이용 동의 체크박스
      openPrivateTerms: Boolean, // 개인정보 수집 및 이용 동의 자세히 보기
      nationsModal: Boolean, // 국가 선택 팝업
      nationItems: Array, // 국가 선택 data array
      // 외국인
      foreigner: {
        // 국내 거주 외국인
        birthDate: String, // 생년월일
        mobileNo: String, // 휴대폰번호
        name: String, // 이름
      },
      beforeNation: String, // 이전 인증 시 국적
      selectedCountryCode: String, // (외국인) 선택 국적 2자 영문 코드
    },
    locale: String,
  },
  data() {
    return {
      doNotChangeModal: false,
    };
  },
  computed: {
    ...mapState("Firebase", ["zendeskUrl"]),
  },
  methods: {
    // step2로 이동
    toStep2() {
      this.$emit("tostep2");
    },
    //휴대폰 점유 인증
    // toCheckPhoneNumber() {
    //   console.log('휴대폰 점유 인증');
    // },
    // 내국인 선택
    clickKorean() {
      if (this.data.beforeNation == "Y") {
        return (this.doNotChangeModal = true);
      }
      this.data.nationality = "Republic of Korea/대한민국";
      this.data.colorChange = true;
      this.data.selectedKorean = true;
      this.data.selectedForeigner = false;
      this.data.abled = true;
      this.data.domesticYn = "N";
      this.data.liveInAnothers = false;
    },
    // 외국인 선택
    async clickForeigner() {
      // 내국인 - 외국인 교차 선택 불가
      if (this.data.beforeNation == "N") {
        return (this.doNotChangeModal = true);
      }
      this.data.nationality = this.$t(
        "Verification.step1.selectYourNationality"
      );
      this.data.colorChange = true;
      this.data.selectedForeigner = true;
      this.data.selectedKorean = false;
      this.data.abled = true;
      this.data.domesticYn = "N";
      this.data.liveInAnothers = false;
      try {
        const res = await Api.getCountry();
        this.data.nationItems = res.data.result; // 국가 선택 data
        // const exception = res.data.result; // 국가 선택 data
        // this.data.nationItems = exception.filter(ele => ele.cntidx !== 17); // 대한민국 제외
      } catch (error) {}
    },
    // 외국인 > 국가 선택 팝업
    openNationsModal() {
      this.data.nationsModal = true;
    },
    // 국가 라디오 버튼 선택 시
    async changeNationseModal() {
      this.data.nationsModal = false; //팝업 닫힘
      // 선택한 국가 오브젝트
      const selectedCountry = _.find(
        this.data.nationItems,
        (ele) => ele.cntName === this.data.nationality.split("/")[0]
      );
      this.data.selectedCountryCode = selectedCountry.cntCode; // 선택한 국가 2자 영문 코드
    },
    // 국내 거주 선택
    clickLiveKorea() {
      CookieControl.setCookie("residence", "kr");
      this.data.domesticYn = "Y";
      this.data.liveInAnothers = false;
    },
    // 국내 비거주 선택
    clickLiveOter() {
      CookieControl.setCookie("residence", "other");
      this.data.domesticYn = "N";
      this.data.liveInAnothers = true;
    },
    // 개인정보 수집 및 이용 동의 페이지로 이동
    toPrivateTerms() {
      this.data.openPrivateTerms = true;
    },

    // 신원인증 시작으로 이동
    toStep1() {
      this.defaultPage = true;
      this.data.openPrivateTerms = false;
    },
    // 내국인/외국인 교차 불가 팝업 확인 버튼
    clickOkButton() {
      this.doNotChangeModal = false;
    },
  },
};
</script>
<style lang="scss" scoped>
.defaultColor {
  color: #333;
}
.content-wrap {
  position: relative;
  /* font-size: 12px; */
  color: #333;
  .step {
    .top-wrap {
      .step-title {
        font-size: 14px;
        font-weight: 500;
      }
    }
    .noti-try {
      font-size: 14px;
      font-weight: 500;
      text-align: center;
      color: #333333;
    }
    .round-button-wrap {
      position: relative;
      height: 64px;
      .round-button {
        position: absolute;
        top: 20px;
        left: 50%;
        transform: translateX(-50%);
        width: 208px;
        height: 64px;
        padding: 0 36px;
        border-radius: 162px;
        border: solid 1px #dcdfe3;
        background-color: #ffffff;
      }
    }
    .content-wrap {
      .item {
        .title {
          margin-bottom: 8px;
        }
        .button-wrap {
          .detail-noti {
            color: #afafaf;
          }
        }
      }
    }
    .center-content-wrap {
      position: relative;
      height: 176px;
      margin-bottom: 216px;
      .content {
        position: absolute;
        top: 60px;
        left: 50%;
        transform: translateX(-50%);
        .round {
          width: 58px;
          height: 58px;
          margin-left: 44px;
          padding: 16px 16px 16px;
          border: solid 1px rgba(51, 51, 51, 0.1);
          background-color: #fff;
        }
      }
    }
    .item {
      .detail {
        &.dropdown {
          position: relative;
          color: #333;
          background-color: #fff;
        }
      }
    }
  }
  // step number
  .step-number {
    .number {
      width: 20px;
      height: 20px;
      text-align: center;
      color: #dcdfe3;
      border-radius: 2px;
      background-color: #f7f8fa;
      &.active {
        color: #fff;
        background-color: #333;
      }
    }
  }
  // 하단 버튼
  button.next-button {
    width: 100%;
    padding: 10px 0;
    /* font-size: 12px; */
    border-radius: 2px;
    border: 1px solid #00b473;
    background-color: #00b473;
    &.bottom {
      position: absolute;
      bottom: 32px;
      left: 50%;
      transform: translateX(-50%);
      width: calc(100% - 24px);
    }
    &:disabled {
      border: solid 1px #dadada !important;
      background-color: #dadada !important;
    }
  }
  // 항목 선택 버튼 공통
  button.default {
    width: 100%;
    padding: 10px 0;
    color: #333;
    border-radius: 2px;
    border: solid 1px #dcdfe3;
    background-color: #fff;
    &:disabled {
      color: #afafaf !important;
      border: solid 1px #dcdfe3 !important;
      background-color: #f7f8fa !important;
    }
    &.half {
      width: calc((100% - 12px) / 2);
    }
    &.select-wrap {
      text-align: left !important;
    }
    &.disabled {
      color: #afafaf;
      background-color: #f7f8fa;
    }
    &.abled {
      color: #333;
      background-color: #fff;
    }
    &.selected {
      border: solid 1px #00b473;
      background-color: rgba(0, 180, 115, 0.05);
      // &:before {
      //   content: '';
      //   position: absolute;
      //   top: 12px;
      //   left: 12px;
      //   width: 14px;
      //   height: 14px;
      //   background-image: url("~/src/assets/img/mypage/check_ic_confirm.svg");
      // }
    }
  }
  .button-wrap {
    position: relative;
    &.select-box {
      &.foreigner {
        padding: 10px 15px;
        border: solid 1px #dcdfe3;
        border-radius: 2px;
      }
      button.default {
        padding: 10px 9px;
      }
      &:after {
        content: "";
        position: absolute;
        top: 13px;
        right: 9px;
        width: 6.7px;
        height: 12px;
        background-image: url("../../../../../../assets/img/mypage/button_arrow_right_icon.svg");
        background-size: 6.7px 12px;
        background-repeat: no-repeat;
      }
    }
    .detail-noti {
      color: #afafaf;
    }
  }
  .dropdown-list {
    list-style: none;
    li {
      padding: 20px 12px;
      font-size: 12px;
      font-weight: 500;
      ul {
        list-style: none;
      }
    }
  }
}
</style>
